import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import i18n, { t } from 'i18next';

const ReportSlice = createSlice({
    name: 'report',
    initialState: {
        retrieveLastReportsByUserId: {},
        markFilesAsRead: {},
        downloadReportByName: {},
        notificationList: [],
        toastShown: 'false',
        notificationCount: 0,
        update: false,
        errorCode:'',
    },
    reducers: {
        setNotificationList: (state, action) => {
            state.notificationList = action.payload;
        },
        setToastShown: (state, action) => {
            state.toastShown = action.payload;
        },
        setNotificationCount: (state, action) => {
            state.notificationCount = action.payload;
        },
        setUpdate: (state, action) => {
            state.update = action.payload;
        },
        setErrorCode: (state, action) => {
            state.errorCode = action.payload;
        },
    },
    extraReducers: {
        'report/retrieveLastReportsByUserId/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.retrieveLastReportsByUserId = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'report/markFilesAsRead/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.markFilesAsRead = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'report/downloadReportByName/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.downloadReportByName = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
    }
});
export const { setNotificationList, setToastShown, setUpdate,setErrorCode, setNotificationCount } = ReportSlice.actions;
export default ReportSlice.reducer;
